module.exports = __webpack_public_path__ + "static/media/photo.22c902da.svg";